import { Grid, Stack, Button, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import VigourHistogram from "./VigourHistogram";
import React, { useState } from "react";
import VigourVariableRateSlider from "./VigourVariableRateSlider";
import classes from "./VigourVariableRateStep.module.css";
import { VariableRates } from "./VigourTaskmap";

const getAffectedTrees = (
  rates: VariableRates,
  sortedData: number[],
): number => {
  return rates.entries().reduce((accumulator, [vigourClass, depth]) => {
    return depth > 0
      ? accumulator + sortedData.filter((value) => value === vigourClass).length
      : accumulator;
  }, 0);
};

export default function VigourVariableRateStep({
  setRates,
  sortedData,
  onSubmit,
  loading,
  rates,
  header,
}: {
  sortedData: number[];
  setRates: (rates: VariableRates) => void;
  onSubmit: () => void;
  loading: boolean;
  rates: VariableRates;
  header: React.ReactNode;
}): React.ReactNode {
  const { t } = useTranslation();
  const [countAffectedTrees, setCountAffectedTrees] = useState(0);

  const onRatesChange = (rates: VariableRates) => {
    const affectedTrees = Math.round(
      (getAffectedTrees(rates, sortedData) / sortedData.length) * 100,
    );
    setCountAffectedTrees(affectedTrees);
    setRates(rates);
  };

  return (
    <>
      <Grid size={12}>
        <Box sx={{ display: "flex", alignItems: "baseline", gap: 2 }}>
          <h1>{header}</h1>
        </Box>
        <Grid container spacing={1} className={classes.topGrid}>
          <Grid
            size={{ xs: 12, md: 7 }}
            sx={{
              order: { xs: 2, md: 1 },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              overflow: "hidden",
              width: "100%",
            }}
          >
            <VigourVariableRateSlider
              rates={rates}
              onRatesChange={onRatesChange}
            />
          </Grid>
          <Grid
            container
            size={{ xs: 12, md: 5 }}
            spacing={0}
            sx={{ order: { xs: 1, md: 2 } }}
            alignItems="center"
            justifyContent="center"
            className={classes.histogramContainer}
          >
            <VigourHistogram sortedData={sortedData} rates={rates} />
          </Grid>
        </Grid>
        <Grid className={classes.bottomGrid}>
          <Stack
            direction="column"
            spacing={2}
            className={classes.downloadButtonStack}
          >
            <Button
              variant="contained"
              size="large"
              onClick={onSubmit}
              loading={loading}
              disabled={countAffectedTrees > 0 ? false : true}
            >
              {t("button.generate")}
            </Button>
            <p>
              {t("taskmap.download.description", { n: countAffectedTrees })}
            </p>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
}
